import { useEffect, useState } from "react";
import { api } from "../../../../service/api";
import { MileageDTO } from "../../../../dtos/MileageDTO";
import { useSearchParams } from "react-router-dom";

export function useListMileage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [dataList, setDataList] = useState<MileageDTO[]>([]);

  const [searchParams] = useSearchParams();

  const search = searchParams.get("search") ?? "";
  const start_date = searchParams.get("start_date") ?? "";
  const end_date = searchParams.get("end_date") ?? "";

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        `company/car/mileage/list?start_date=${start_date}&end_date=${end_date}&search=${search}`
      );
      setDataList(response.data);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, start_date, end_date]);

  return {
    dataList,
    loading,
    error,
    refetch: fetchData,
  };
}
